<ng-container *ngFor="let item of items">
  <button
    *ngIf="getVisibleItem(item)"
    tuiIconButton
    type="button"
    appearance="icon"
    size="s"
    [tuiHint]="item.title | translate"
    (click)="onClickItem($event, item)"
  >
    <app-icon [color]="item.color" [src]="item.icon"></app-icon>
  </button>
</ng-container>
